import _ from 'underscore';

// Strict latitude longitude regex that validates values within the correct range - https://stackoverflow.com/a/18690202/6392285
const latitudeLongitudeRegex = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;

/**
* Tests is a search query is for a lat/long coordinate.
 * @param {String} s - Query to test.
 * @returns {Boolean} - True if query is a valid lat/long coordinate.
 */
export function isLatLongCoordinates(s) {
  if (_.isString(s)) {
    return latitudeLongitudeRegex.test(s.trim());
  }
  return false;
}
